<template>
  <div class="policy-app-title">이용약관</div>

  <div class="policy-box app">
    <Policy/>
  </div>

</template>


<script>
import Policy from '@/components/terms/Policy.vue';

export default {
  components: {  
    Policy,
  },  
}
</script>
